import { endOfMonth, endOfWeek, isDateKeyBefore } from "../../lib/dateNav";

export type TodayPeriodMode = "day" | "week" | "month";

/** True when the viewed period ends entirely before the earliest saved iOS snapshot. */
export function isPreInstallationPeriod(
  mode: TodayPeriodMode,
  selectedDate: string,
  earliestDataDate: string | null | undefined,
): boolean {
  if (!earliestDataDate) return false;

  if (mode === "day") {
    return isDateKeyBefore(selectedDate, earliestDataDate);
  }
  if (mode === "week") {
    return isDateKeyBefore(endOfWeek(selectedDate), earliestDataDate);
  }
  return isDateKeyBefore(endOfMonth(selectedDate), earliestDataDate);
}
